// 🕯️ Candlestick pattern detection — classic formations marked on the chart.
// Descriptive only: a pattern is a historical formation, never a guarantee.

const body = (c) => Math.abs(c.close - c.open);
const isBull = (c) => c.close > c.open;
const isBear = (c) => c.close < c.open;
const mid = (c) => (c.open + c.close) / 2;

export const PATTERNS = [
  { id: "morning", label: "Morning Star", bull: true },
  { id: "evening", label: "Evening Star", bull: false },
  { id: "soldiers", label: "Three White Soldiers", bull: true },
  { id: "crows", label: "Three Black Crows", bull: false },
  { id: "bullEngulf", label: "Bullish Engulfing", bull: true },
  { id: "bearEngulf", label: "Bearish Engulfing", bull: false },
  { id: "piercing", label: "Piercing Line", bull: true },
];

const CHECKS = {
  bullEngulf: (c0, c1) => c1 && isBear(c1) && isBull(c0) && c0.open <= c1.close && c0.close >= c1.open && body(c0) > body(c1),
  bearEngulf: (c0, c1) => c1 && isBull(c1) && isBear(c0) && c0.open >= c1.close && c0.close <= c1.open && body(c0) > body(c1),
  piercing: (c0, c1) => c1 && isBear(c1) && isBull(c0) && c0.open < c1.close && c0.close > mid(c1) && c0.close < c1.open,
  morning: (c0, c1, c2) => c2 && isBear(c2) && body(c1) < body(c2) * 0.4 && isBull(c0) && c0.close > mid(c2),
  evening: (c0, c1, c2) => c2 && isBull(c2) && body(c1) < body(c2) * 0.4 && isBear(c0) && c0.close < mid(c2),
  soldiers: (c0, c1, c2) => c2 && isBull(c0) && isBull(c1) && isBull(c2) && c0.close > c1.close && c1.close > c2.close
    && body(c0) > (c0.high - c0.low) * 0.5 && body(c1) > (c1.high - c1.low) * 0.5,
  crows: (c0, c1, c2) => c2 && isBear(c0) && isBear(c1) && isBear(c2) && c0.close < c1.close && c1.close < c2.close
    && body(c0) > (c0.high - c0.low) * 0.5 && body(c1) > (c1.high - c1.low) * 0.5,
};

export function detectPatterns(candles, enabledIds, maxMarkers = 14) {
  if (!candles?.length || !enabledIds?.length) return [];
  const enabled = PATTERNS.filter((p) => enabledIds.includes(p.id));
  const out = [];
  const n = candles.length;
  for (let i = Math.max(2, n - 150); i < n; i += 1) {
    const c0 = candles[i];
    const c1 = candles[i - 1];
    const c2 = candles[i - 2];
    enabled.forEach((p) => {
      if (CHECKS[p.id]?.(c0, c1, c2)) {
        out.push({
          time: c0.time,
          position: p.bull ? "belowBar" : "aboveBar",
          color: p.bull ? "#22c55e" : "#ef4444",
          shape: p.bull ? "arrowUp" : "arrowDown",
          text: p.label,
        });
      }
    });
  }
  return out.slice(-maxMarkers);
}
